module.exports = __webpack_public_path__ + "img/uk.f6f5c863.png";